/**
 * 학원 소개의 읽기 보조 효과. 본문과 목차 이동은 JS 없이도 그대로 제공한다.
 * 반복 타이머나 스크롤 제어 없이, 화면에 들어온 도해만 한 번 강조한다.
 */
const introduceEducationInstances = new WeakMap();

function initIntroduceEducation(
    root = typeof document !== 'undefined' ? document.querySelector('.pc-introduce-page') : null,
    win = root && root.ownerDocument.defaultView,
) {
    if (!root || !win || !root.matches('.pc-introduce-page')) {
        return () => {};
    }
    if (introduceEducationInstances.has(root)) {
        return introduceEducationInstances.get(root);
    }

    const reveals = Array.from(root.querySelectorAll('[data-edu-reveal]'));
    const media = typeof win.matchMedia === 'function'
        ? win.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
    const cycleCleanups = [];
    let observer = null;

    const summaries = {
        concept: '1~7주: 자체교재로 개념을 배우고, 7주차에 1차 인증으로 확인합니다.',
        application: '8~12주: 우공비 발전심화로 응용하며, 10주차에 2차 인증으로 확인합니다.',
    };

    root.querySelectorAll('[data-edu-cycle]').forEach((cycle) => {
        const buttons = Array.from(cycle.querySelectorAll('button[data-edu-stage]'));
        const summary = cycle.querySelector('[data-edu-cycle-summary]');

        function selectStage(stage) {
            if (!Object.prototype.hasOwnProperty.call(summaries, stage)) {
                return;
            }
            cycle.dataset.eduActive = stage;
            buttons.forEach((button) => {
                button.setAttribute('aria-pressed', String(button.dataset.eduStage === stage));
            });
            if (summary) {
                summary.textContent = summaries[stage];
            }
        }

        function onCycleClick(event) {
            const button = event.target.closest('button[data-edu-stage]');
            if (buttons.includes(button)) {
                selectStage(button.dataset.eduStage);
            }
        }

        selectStage(cycle.dataset.eduActive === 'application' ? 'application' : 'concept');
        cycle.addEventListener('click', onCycleClick);
        cycleCleanups.push(() => cycle.removeEventListener('click', onCycleClick));
    });

    function applyMotionPreference() {
        const enabled = !(media && media.matches);
        root.dataset.eduMotion = enabled ? 'on' : 'off';

        if (observer) {
            observer.disconnect();
            observer = null;
        }
        if (!enabled || typeof win.IntersectionObserver !== 'function') {
            return;
        }

        const nextObserver = new win.IntersectionObserver((entries) => {
            // 선호 변경 직전 큐에 들어간 observer 콜백도 움직임을 다시 켜지 않는다.
            if (observer !== nextObserver || root.dataset.eduMotion !== 'on') {
                return;
            }
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.target.dataset.eduSeen !== 'true') {
                    entry.target.dataset.eduSeen = 'true';
                    nextObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12 });
        observer = nextObserver;

        reveals.forEach((element) => {
            if (element.dataset.eduSeen !== 'true') {
                observer.observe(element);
            }
        });
    }

    if (media && typeof media.addEventListener === 'function') {
        media.addEventListener('change', applyMotionPreference);
    } else if (media && typeof media.addListener === 'function') {
        media.addListener(applyMotionPreference);
    }
    applyMotionPreference();

    function cleanup() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        if (media && typeof media.removeEventListener === 'function') {
            media.removeEventListener('change', applyMotionPreference);
        } else if (media && typeof media.removeListener === 'function') {
            media.removeListener(applyMotionPreference);
        }
        cycleCleanups.forEach((removeListener) => removeListener());
        root.dataset.eduMotion = 'off';
        introduceEducationInstances.delete(root);
    }

    introduceEducationInstances.set(root, cleanup);
    return cleanup;
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initIntroduceEducation };
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initIntroduceEducation(), { once: true });
    } else {
        initIntroduceEducation();
    }
}
